// import React, { useState, useEffect } from 'react';
// import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
// import { SwiperSlide } from 'swiper/react';
// import siteQueries from '../../queries/siteQueries';
// import { BASE_URL } from '../../apis/api';

// import DelegateBtn from '../../images/logo/delegate-reg-button.png';
// import DelegateBtnHover from '../../images/logo/delegate-reg-button-2-hover.png';
// import StudentBtn from '../../images/logo/student-reg-button.png';
// import StudentBtnHover from '../../images/logo/student-reg-button-2-hover.png';

// import DelegateBtnFirst from '../../images/logo/delegate-reg-button-2.png';
// import DelegateBtnFirstHover from '../../images/logo/delegate-reg-button-hover.png';
// import StudentBtnFirst from '../../images/logo/student-reg-button-2.png';
// import StudentBtnFirstHover from '../../images/logo/student-reg-button-hover.png';

// import ILFKLogo from '../../images/logo/ILFK-logo.png';
// import ILFKLogo2 from '../../images/logo/ILFK-logo-2.png';
// import CombinedLogo from '../../images/logo/group-logo-for-new-banner.png';
// import CombinedLogoWhite from '../../images/logo/group-logo-for-new-bannerOld.png';
// import { useNavigate } from 'react-router-dom';
// import RouteConstants from '../../constant/Routeconstant';

// import slider from '../../images/slider/sliderimage.jpg';

// const parseLocalizedField = (field, lang = 'en') => {
//     try {
//         const obj = JSON.parse(field);
//         return obj?.[lang] || '';
//     } catch {
//         return field;
//     }
// };

// const HeroCarousel = () => {
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const [sliderImages, setSliderImages] = useState([]);
//     const navigate = useNavigate();

//     // Static titles and descriptions (mapped by index)
//     const localData = [
//         {
//             title: JSON.stringify({
//                 en: 'International <br/> Literatural Festival <br/> of Kerala',
//             }),
//             description: JSON.stringify({
//                 en: 'Join the international literary festival in Kerala.',
//                 en: 'Literature | Culture | Progress',
//             }),
//             date: JSON.stringify({
//                 en: 'August 17 - 21, 2025. Thrissur, Kerala',
//             }),
//             organize: JSON.stringify({
//                 en: 'Organised by Kerala Sahitya Akademi And Department of Cultural <br/> Affairs, Government of Kerala',
//             }),
//             alignment: 'left',
//         },
//         {
//             title: JSON.stringify({
//                 en: 'International Literatural <br/> Festival of Kerala',
//             }),
//             description: JSON.stringify({
//                 en: 'Kerala Sahitya Akademi, Thrissur, Kerala',
//             }),
//             date: JSON.stringify({
//                 en: 'August 17 - 21, 2025. Thrissur, Kerala',
//             }),
//             organize: JSON.stringify({
//                 en: 'Organised by Kerala Sahitya Akademi And Department of Cultural <br/> Affairs, Government of Kerala',
//             }),
//             alignment: 'left',
//         },
//         {
//             title: JSON.stringify({
//                 en: 'Global Voices on <br/> One Stage',
//             }),
//             description: JSON.stringify({
//                 en: 'Meet authors, thinkers, and artists from around the world.',
//             }),
//             date: JSON.stringify({
//                 en: 'August 17 - 21, 2025. Thrissur, Kerala',
//             }),
//             alignment: 'left',
//         },
//     ];

//     const parseLocalizedField = (field, lang = 'en') => {
//         const parsed = typeof field === 'string' ? JSON.parse(field) : field;
//         return parsed?.[lang] || '';
//     };

//     const sliderQuery = siteQueries.useSliderMutation(
//         async (response) => {
//             const slides = (response?.data || []).map((item, index) => ({
//                 id: item.id || index + 1,
//                 image: item.photo ? `${BASE_URL}/${item.photo}` : '',
//             }));
//             setSliderImages(slides.slice(0, 3)); // only take 3 items
//         },
//         {
//             onError: (error) => {
//                 console.error('Error loading slides:', error);
//             },
//         }
//     );

//     useEffect(() => {
//         sliderQuery.mutateAsync({});
//     }, []);

//     useEffect(() => {
//         if (sliderImages.length === 0) return;
//         const timer = setInterval(() => {
//             setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
//         }, 5000);
//         return () => clearInterval(timer);
//     }, [sliderImages.length]);

//     const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
//     const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
//     const goToSlide = (index) => setCurrentSlide(index);

//     const getAlignmentClass = (alignment) => {
//         switch (alignment) {
//             case 'left': return 'text-left items-start';
//             case 'right': return 'text-right items-end';
//             case 'center': return 'text-center items-center';
//             default: return 'text-left items-start';
//         }
//     };

//     <style>
//         {`
//     .banner-btns {
//       padding: 5px;
//     }

//     .banner-btns img {
//       width: 51px;
//       height: 49px;
//     }

//     .banner-btns span {
//       width: 66px;
//       height: 29px;
//       display: inline-flex;
//       justify-content: center;
//       align-items: center;
//       font-size: 17px;
//     }
//   `}
//     </style>

//     return (
//         <div className="relative h-[88vh] md:h-[88vh] sm:h-auto overflow-hidden slider">
//             <div className="relative h-full w-full">
//                 {sliderImages.map((slide, index) => {
//                     const local = localData[index] || {};
//                     return (
//                         <div
//                             key={slide.id}
//                             className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
//                         >
//                             {/* Background Image */}
//                             <div className="absolute inset-0 z-0">
//                                 <SwiperSlide className="swiper-slide h-full w-full">
//                                     <img
//                                         src={slide.image}
//                                         alt="ILFK Banners"
//                                         // className={`w-full h-full object-cover ${index === 0 ? 'object-left' : 'object-center'} md:object-center`}
//                                         className={`w-full h-full object-cover ${index === 0 ? 'object-left' : 'object-center'}`}
//                                         fetchpriority="high"
//                                     />
//                                 </SwiperSlide>
//                             </div>

//                             {index === 0 && (
//                                 <div className="relative h-full">
//                                     <div className="relative h-full grid grid-cols-1 md:grid-cols-2 items-end z-20 px-4 pb-8">
//                                         <div className="hidden md:flex justify-end">
//                                             <div className="w-0 md:w-[50px] lg:w-[100px]"></div>
//                                         </div>

//                                         <div className="max-w-full md:max-w-2xl text-center md:text-left">
//                                             <div className="flex items-start justify-center md:justify-start gap-6 flex-wrap mb-4">
//                                                 <img
//                                                     src={ILFKLogo2}
//                                                     alt="ILFK logo"
//                                                     className="w-[200px] h-[100px] lg:w-[349px] lg:h-[254px] md:w-[249px] md:h-[154px] object-contain"
//                                                     fetchpriority="high"
//                                                 />
//                                             </div>

//                                             <div>
//                                                 <div
//                                                     className="text-white  lg:text-black font-bold mb-2 text-[14px] md:text-[20px] leading-tight"
//                                                     dangerouslySetInnerHTML={{ __html: parseLocalizedField(local.organize, 'en') }}
//                                                 />

//                                                 <span className="text-white  lg:text-black font-normal text-[16px] md:text-[20px] mb-4 leading-relaxed block">
//                                                     {parseLocalizedField(local.description, 'en')}
//                                                 </span>

//                                                 <div className="flex justify-start flex-col sm:flex-row  mb-4 mt-4 items-center md:justify-start">
//                                                     {/* <button className='delegateBtn' onClick={() => { navigate(RouteConstants.REGISTRATIONFORM) }}>
//                                                         <img src={DelegateBtnFirst} alt="Delegate-img" className="w-[240px] h-[50px] sm:w-[300px] sm:h-[57px] object-contain" />
//                                                     </button> */}
//                                                     {/* <button className='studentdelegateBtn' onClick={() => { navigate(RouteConstants.REGISTRATIONFORM) }}>
//                                                         <img src={StudentBtnFirst} alt="Delegate-Student-img" className="w-[240px] h-[50px] lg:w-[353px] sm:w-[300px] sm:h-[57px] object-contain" />
//                                                     </button> */}

//                                                     <button
//                                                         className="delegateBtn group relative w-[240px] h-[50px] sm:w-[300px] sm:h-[57px]"
//                                                         onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
//                                                     >
//                                                         {/* Default image */}
//                                                         <img
//                                                             src={DelegateBtnFirst}
//                                                             alt="Delegate-img"
//                                                             className="absolute top-0 left-0 w-full h-full object-contain transition-opacity duration-300 group-hover:opacity-0"
//                                                         />
//                                                         {/* Hover image */}
//                                                         <img
//                                                             src={DelegateBtnHover}
//                                                             alt="Delegate-img-hover"
//                                                             className="absolute top-0 left-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100"
//                                                         />
//                                                     </button>

//                                                     <button
//                                                         className="studentdelegateBtn group relative w-[240px] h-[50px] sm:w-[300px] sm:h-[57px] lg:w-[353px]"
//                                                         onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
//                                                     >
//                                                         {/* Default image */}
//                                                         <img
//                                                             src={StudentBtnFirst}
//                                                             alt="Delegate-Student-img"
//                                                             className="absolute top-0 left-0 w-full h-full object-contain transition-opacity duration-300 group-hover:opacity-0"
//                                                         />
//                                                         {/* Hover image */}
//                                                         <img
//                                                             src={StudentBtnHover}
//                                                             alt="Delegate-Student-hover"
//                                                             className="absolute top-0 left-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100"
//                                                         />
//                                                     </button>
//                                                 </div>

//                                                 <img
//                                                     src={CombinedLogoWhite}
//                                                     alt="KeralaLogo"
//                                                     className="block lg:hidden w-full max-w-[230px] md:max-w-[339px] h-auto object-contain mx-auto md:mx-0"
//                                                     fetchpriority="high"
//                                                 />

//                                                 {/* Web Image (lg and up) */}
//                                                 <img
//                                                     src={CombinedLogo}
//                                                     alt="KeralaLogo"
//                                                     className="hidden lg:block w-full max-w-[230px] md:max-w-[369px] h-auto object-contain mx-auto md:mx-0"
//                                                     fetchpriority="high"
//                                                 />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}

//                             {index != 0 && (
//                                 <div className="relative h-full w-full flex items-center justify-center">
//                                     {/* Bottom Centered Block */}
//                                     <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-full px-4 py-6 flex flex-col md:flex-row justify-center md:items-center  md:gap-6 text-white">

//                                         {/* 1. Logo Image */}
//                                         <div className="flex justify-center md:justify-start">
//                                             <img
//                                                 src={ILFKLogo}
//                                                 alt="ILFK Logo"
//                                                 className="w-[200px] h-[100px] md:w-[359px] md:h-[254px] object-contain"
//                                                 fetchpriority="high"
//                                             />
//                                         </div>

//                                         {/* 3. Organised By and Buttons */}
//                                         <div className="flex flex-col items-center md:items-base  pb-1 md:pb-2">
//                                             <div
//                                                 className="font-bold text-[14px] md:text-[22px] text-center md:text-left mb-2"
//                                                 dangerouslySetInnerHTML={{
//                                                     __html: parseLocalizedField(local.organize, 'en'),
//                                                 }}
//                                             ></div>


//                                             <div className="flex flex-col sm:flex-row mb-4 mt-4 items-center justify-start md:justify-start">
//                                                 {/* <button className='delegateBtn' onClick={() => { navigate(RouteConstants.REGISTRATIONFORM) }}>
//                                                     <img src={DelegateBtn} alt="Delegate-img" className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain" />
//                                                 </button>
//                                                 <button className='studentdelegateBtn' onClick={() => { navigate(RouteConstants.REGISTRATIONFORM) }}>
//                                                     <img src={StudentBtn} alt="Delegate-Student-img" className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain" />
//                                                 </button> */}

//                                                 {/* Button 1 - Delegate Button */}
//                                                 <button
//                                                     className="delegateBtn group relative"
//                                                     onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
//                                                 >
//                                                     {/* Default Image */}
//                                                     <img
//                                                         src={DelegateBtn}
//                                                         alt="Delegate"
//                                                         className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain group-hover:opacity-0 transition-opacity duration-300"
//                                                     />
//                                                     {/* Hover image */}
//                                                     <img
//                                                         src={DelegateBtnFirstHover}
//                                                         alt="Delegate Hover"
//                                                         className="absolute top-0 left-0 w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                                                     />
//                                                 </button>

//                                                 {/* Button 2 - Student Button */}
//                                                 <button
//                                                     className="studentdelegateBtn group relative"
//                                                     onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
//                                                 >
//                                                     {/* Default Image */}
//                                                     <img
//                                                         src={StudentBtn}
//                                                         alt="Student Delegate"
//                                                         className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain group-hover:opacity-0 transition-opacity duration-300"
//                                                     />
//                                                     {/* Hover image */}
//                                                     <img
//                                                         src={StudentBtnFirstHover}
//                                                         alt="Student Delegate Hover"
//                                                         className="absolute top-0 left-0 w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                                                     />
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         <div className="text-center md:text-start items-center md:items-start">
//                                             <img
//                                                 src={CombinedLogoWhite}
//                                                 alt="KeralaLogo"
//                                                 className="w-full max-w-[230px] md:max-w-[339px] h-auto object-contain mx-auto md:mx-0"
//                                                 fetchpriority="high"
//                                             />
//                                         </div>

//                                     </div>
//                                 </div>

//                             )}
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* Arrows */}
//             <button onClick={prevSlide} className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all z-30">
//                 <FaChevronLeft className="w-4 h-4 sm:w-6 sm:h-6" />
//             </button>
//             <button onClick={nextSlide} className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all z-30">
//                 <FaChevronRight className="w-4 h-4 sm:w-6 sm:h-6" />
//             </button>
//         </div>

//     );
// };

// export default HeroCarousel;

import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SwiperSlide } from 'swiper/react';
import siteQueries from '../../queries/siteQueries';
import { BASE_URL } from '../../apis/api';

import DelegateBtn from '../../images/logo/delegate-reg-button.png';
import DelegateBtnHover from '../../images/logo/delegate-reg-button-2-hover.png';
import StudentBtn from '../../images/logo/student-reg-button.png';
import StudentBtnHover from '../../images/logo/student-reg-button-2-hover.png';

import DelegateBtnFirst from '../../images/logo/delegate-reg-button-2.png';
import DelegateBtnFirstHover from '../../images/logo/delegate-reg-button-hover.png';
import StudentBtnFirst from '../../images/logo/student-reg-button-2.png';
import StudentBtnFirstHover from '../../images/logo/student-reg-button-hover.png';

import ILFKLogo from '../../images/logo/ILFK-logo.png';
import ILFKLogo2 from '../../images/logo/ILFK-logo-2.png';
import CombinedLogo from '../../images/logo/group-logo-for-new-banner.png';
import CombinedLogoWhite from '../../images/logo/group-logo-for-new-bannerOld.png';
import { useNavigate } from 'react-router-dom';
import RouteConstants from '../../constant/Routeconstant';

import slider from '../../images/slider/sliderimage.jpg';

const parseLocalizedField = (field, lang = 'en') => {
    try {
        const obj = JSON.parse(field);
        return obj?.[lang] || '';
    } catch {
        return field;
    }
};

const HeroCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [sliderImages, setSliderImages] = useState([]);
    const [isApiLoaded, setIsApiLoaded] = useState(false);
    const navigate = useNavigate();

    // Static image as initial slide
    const staticSlide = {
        id: 'static',
        image: slider,
    };

    // Static titles and descriptions (mapped by index)
    const localData = [
        {
            title: JSON.stringify({
                en: 'International <br/> Literatural Festival <br/> of Kerala',
            }),
            description: JSON.stringify({
                en: 'Join the international literary festival in Kerala.',
                en: 'Literature | Culture | Progress',
            }),
            date: JSON.stringify({
                en: 'August 17 - 21, 2025. Thrissur, Kerala',
            }),
            organize: JSON.stringify({
                en: 'Organised by Kerala Sahitya Akademi And Department of Cultural <br/> Affairs, Government of Kerala',
            }),
            alignment: 'left',
        },
        {
            title: JSON.stringify({
                en: 'International Literatural <br/> Festival of Kerala',
            }),
            description: JSON.stringify({
                en: 'Kerala Sahitya Akademi, Thrissur, Kerala',
            }),
            date: JSON.stringify({
                en: 'August 17 - 21, 2025. Thrissur, Kerala',
            }),
            organize: JSON.stringify({
                en: 'Organised by Kerala Sahitya Akademi And Department of Cultural <br/> Affairs, Government of Kerala',
            }),
            alignment: 'left',
        },
        {
            title: JSON.stringify({
                en: 'Global Voices on <br/> One Stage',
            }),
            description: JSON.stringify({
                en: 'Meet authors, thinkers, and artists from around the world.',
            }),
            date: JSON.stringify({
                en: 'August 17 - 21, 2025. Thrissur, Kerala',
            }),
            alignment: 'left',
        },
    ];

    // Get current slides (static initially, then API slides)
    const getCurrentSlides = () => {
        if (!isApiLoaded || sliderImages.length === 0) {
            return [staticSlide];
        }
        return sliderImages;
    };

    const currentSlides = getCurrentSlides();

    const sliderQuery = siteQueries.useSliderMutation(
        async (response) => {
            const slides = (response?.data || []).map((item, index) => ({
                id: item.id || index + 1,
                image: item.photo ? `${BASE_URL}/${item.photo}` : '',
            }));
            
            // Filter out empty images
            const validSlides = slides.filter(slide => slide.image).slice(0, 3);
            
            if (validSlides.length > 0) {
                setSliderImages(validSlides);
                setIsApiLoaded(true);
                // Reset to first slide when API data loads
                setCurrentSlide(0);
            }
        },
        {
            onError: (error) => {
                console.error('Error loading slides:', error);
                // Keep showing static image on error
                setIsApiLoaded(false);
            },
        }
    );

    useEffect(() => {
        sliderQuery.mutateAsync({});
    }, []);

    // Auto-slide functionality
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % currentSlides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [currentSlides.length]);

    const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % currentSlides.length);
    const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + currentSlides.length) % currentSlides.length);
    const goToSlide = (index) => setCurrentSlide(index);

    const getAlignmentClass = (alignment) => {
        switch (alignment) {
            case 'left': return 'text-left items-start';
            case 'right': return 'text-right items-end';
            case 'center': return 'text-center items-center';
            default: return 'text-left items-start';
        }
    };

    return (
        <>
            <style>
                {`
                .banner-btns {
                  padding: 5px;
                }

                .banner-btns img {
                  width: 51px;
                  height: 49px;
                }

                .banner-btns span {
                  width: 66px;
                  height: 29px;
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 17px;
                }
              `}
            </style>

            <div className="relative h-[88vh] md:h-[88vh] sm:h-auto overflow-hidden slider">
                <div className="relative h-full w-full">
                    {currentSlides.map((slide, index) => {
                        const local = localData[index] || localData[0]; // Fallback to first local data
                        return (
                            <div
                                key={slide.id}
                                className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
                            >
                                {/* Background Image */}
                                <div className="absolute inset-0 z-0">
                                    <SwiperSlide className="swiper-slide h-full w-full">
                                        <img
                                            src={slide.image}
                                            alt="ILFK Banners"
                                            className={`w-full h-full object-cover ${index === 0 ? 'object-left' : 'object-center'}`}
                                            fetchpriority="high"
                                        />
                                    </SwiperSlide>
                                </div>

                                {(index === 0 || !isApiLoaded) && (
                                    <div className="relative h-full">
                                        <div className="relative h-full grid grid-cols-1 md:grid-cols-2 items-end z-20 px-4 pb-8">
                                            <div className="hidden md:flex justify-end">
                                                <div className="w-0 md:w-[50px] lg:w-[100px]"></div>
                                            </div>

                                            <div className="max-w-full md:max-w-2xl text-center md:text-left">
                                                <div className="flex items-start justify-center md:justify-start gap-6 flex-wrap mb-4">
                                                    <img
                                                        src={ILFKLogo2}
                                                        alt="ILFK logo"
                                                        className="w-[200px] h-[100px] lg:w-[349px] lg:h-[254px] md:w-[249px] md:h-[154px] object-contain"
                                                        fetchpriority="high"
                                                    />
                                                </div>

                                                <div>
                                                    <div
                                                        className="text-white lg:text-black font-bold mb-2 text-[14px] md:text-[20px] leading-tight"
                                                        dangerouslySetInnerHTML={{ __html: parseLocalizedField(local.organize, 'en') }}
                                                    />

                                                    <span className="text-white lg:text-black font-normal text-[16px] md:text-[20px] mb-4 leading-relaxed block">
                                                        {parseLocalizedField(local.description, 'en')}
                                                    </span>

                                                    <div className="flex justify-start flex-col sm:flex-row mb-4 mt-4 items-center md:justify-start">
                                                        {/* <button
                                                            className="delegateBtn group relative w-[240px] h-[50px] sm:w-[300px] sm:h-[57px]"
                                                            onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
                                                        >
                                                            <img
                                                                src={DelegateBtnFirst}
                                                                alt="Delegate-img"
                                                                className="absolute top-0 left-0 w-full h-full object-contain transition-opacity duration-300 group-hover:opacity-0"
                                                            />
                                                            <img
                                                                src={DelegateBtnHover}
                                                                alt="Delegate-img-hover"
                                                                className="absolute top-0 left-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                                            />
                                                        </button> */}

                                                        {/* <button
                                                            className="studentdelegateBtn group relative w-[240px] h-[50px] sm:w-[300px] sm:h-[57px] lg:w-[353px]"
                                                            onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
                                                        >
                                                            <img
                                                                src={StudentBtnFirst}
                                                                alt="Delegate-Student-img"
                                                                className="absolute top-0 left-0 w-full h-full object-contain transition-opacity duration-300 group-hover:opacity-0"
                                                            />
                                                            <img
                                                                src={StudentBtnHover}
                                                                alt="Delegate-Student-hover"
                                                                className="absolute top-0 left-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                                            />
                                                        </button> */}
                                                    </div>

                                                    <img
                                                        src={CombinedLogoWhite}
                                                        alt="KeralaLogo"
                                                        className="block lg:hidden w-full max-w-[230px] md:max-w-[339px] h-auto object-contain mx-auto md:mx-0"
                                                        fetchpriority="high"
                                                    />

                                                    <img
                                                        src={CombinedLogo}
                                                        alt="KeralaLogo"
                                                        className="hidden lg:block w-full max-w-[230px] md:max-w-[369px] h-auto object-contain mx-auto md:mx-0"
                                                        fetchpriority="high"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {index !== 0 && isApiLoaded && (
                                    <div className="relative h-full w-full flex items-center justify-center">
                                        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-full px-4 py-6 flex flex-col md:flex-row justify-center md:items-center md:gap-6 text-white">
                                            <div className="flex justify-center md:justify-start">
                                                <img
                                                    src={ILFKLogo}
                                                    alt="ILFK Logo"
                                                    className="w-[200px] h-[100px] md:w-[359px] md:h-[254px] object-contain"
                                                    fetchpriority="high"
                                                />
                                            </div>

                                            <div className="flex flex-col items-center md:items-base pb-1 md:pb-2">
                                                <div
                                                    className="font-bold text-[14px] md:text-[22px] text-center md:text-left mb-2"
                                                    dangerouslySetInnerHTML={{
                                                        __html: parseLocalizedField(local.organize, 'en'),
                                                    }}
                                                ></div>

                                                <div className="flex flex-col sm:flex-row mb-4 mt-4 items-center justify-start md:justify-start">
                                                    {/* <button
                                                        className="delegateBtn group relative"
                                                        onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
                                                    >
                                                        <img
                                                            src={DelegateBtn}
                                                            alt="Delegate"
                                                            className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain group-hover:opacity-0 transition-opacity duration-300"
                                                        />
                                                        <img
                                                            src={DelegateBtnFirstHover}
                                                            alt="Delegate Hover"
                                                            className="absolute top-0 left-0 w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                        />
                                                    </button>

                                                    <button
                                                        className="studentdelegateBtn group relative"
                                                        onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
                                                    >
                                                        <img
                                                            src={StudentBtn}
                                                            alt="Student Delegate"
                                                            className="w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain group-hover:opacity-0 transition-opacity duration-300"
                                                        />
                                                        <img
                                                            src={StudentBtnFirstHover}
                                                            alt="Student Delegate Hover"
                                                            className="absolute top-0 left-0 w-[240px] h-[50px] sm:w-[318px] sm:h-[57px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                        />
                                                    </button> */}
                                                </div>
                                            </div>

                                            <div className="text-center md:text-start items-center md:items-start">
                                                <img
                                                    src={CombinedLogoWhite}
                                                    alt="KeralaLogo"
                                                    className="w-full max-w-[230px] md:max-w-[339px] h-auto object-contain mx-auto md:mx-0"
                                                    fetchpriority="high"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* Navigation Arrows - Only show if there are multiple slides */}
                {currentSlides.length > 1 && (
                    <>
                        <button 
                            onClick={prevSlide} 
                            className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all z-30"
                        >
                            <FaChevronLeft className="w-4 h-4 sm:w-6 sm:h-6" />
                        </button>
                        <button 
                            onClick={nextSlide} 
                            className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all z-30"
                        >
                            <FaChevronRight className="w-4 h-4 sm:w-6 sm:h-6" />
                        </button>
                    </>
                )}

                {/* Slide indicators - Only show if there are multiple slides */}
                {currentSlides.length > 1 && (
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-30">
                        {currentSlides.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`w-3 h-3 rounded-full transition-all ${
                                    index === currentSlide 
                                        ? 'bg-white' 
                                        : 'bg-white bg-opacity-50 hover:bg-opacity-70'
                                }`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default HeroCarousel;